// extracted by mini-css-extract-plugin
module.exports = {"holder":"round-profile-image_holder__1Duq1","accepted":"round-profile-image_accepted__2gRDD","rejected":"round-profile-image_rejected__3NJ8d"};